import {
  START_SPINNER,
  STOP_SPINNER,
  SET_REPORTING_DATES,
  SWITCH_INTERCOM
} from './mutations-types'

export default {
  [START_SPINNER] (state) {
    state.spinner = true
  },
  [STOP_SPINNER] (state) {
    state.spinner = false
  },
  [SET_REPORTING_DATES] (state, payload) {
    state.reportingDates = payload
  },
  [SWITCH_INTERCOM] (state) {
    state.intercom = !state.intercom
  }
}
